import type { FC } from 'react';
import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import type { SelectOption } from '../declarations/type';

interface SelectFilterProps {
  label: string;
  options: SelectOption[];
  value: string | undefined;
  onChange: (id: string | undefined) => void;
}

export const SelectFilter: FC<SelectFilterProps> = ({
  label,
  options,
  value,
  onChange,
}) => (
  <Autocomplete
    options={options}
    value={options.find((option) => option.id === value) ?? null}
    onChange={(_event, option) => onChange(option?.id)}
    getOptionLabel={(option) => option.label}
    isOptionEqualToValue={(option, selected) => option.id === selected.id}
    size="small"
    renderInput={(params) => <TextField {...params} label={label} />}
  />
);
